"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
/**
 * TODO default parsing logic
 */
//  export const parseResponse = (resp) => {
//     // handle errors
//     return data;
//   };
// **
const instance = axios_1.default.create({
    withCredentials: true,
});
// Override timeout default for the library
// Now all requests using this instance will wait 4 seconds before timing out
instance.defaults.timeout = 4000;
exports.default = instance;
//# sourceMappingURL=instance.js.map